<template>
    <render />
</template>

<script setup lang="ts">
import { h } from 'vue'
import type { ComponentFragment } from '@/graphql/api'

const props = defineProps<{
    data: ComponentFragment
}>()

const render = () => {
    if (import.meta.env.PROD) {
        return h('div')
    }

    return h(
        'div',
        {
            class: 'debug-component',
            style: {
                background: 'white',
                border: '2px solid red',
                width: 'calc(100% - 40px)',
                height: '70vh',
                margin: '20px',
                padding: '20px',
                color: 'red',
                overflow: 'auto',
            },
        },
        [
            h(
                'h3',
                {
                    style: {
                        'font-family': "'Effra', sans-serif",
                        display: 'block',
                        'font-size': '1.5rem',
                        'line-height': '2em',
                        'font-weight': 'bold',
                    },
                },
                `Debug Content Component ${props.data.__typename}`
            ),
            h(
                'pre',
                {
                    style: {
                        display: 'block',
                        'font-family': 'monospace',
                        'white-space': 'pre',
                        margin: '20px 0',
                        'font-size': '0.875rem',
                        'line-height': '1.5em',
                    },
                },
                JSON.stringify(props.data, null, 4)
            ),
        ]
    )
}
</script>
